module.exports = __webpack_public_path__ + "static/media/logo.410c07ee.svg";